<mat-card>
  <mat-card-header>
    <mat-icon mat-card-avatar class="whatsapp"></mat-icon>
    @if (badge() !== null && !whatsappConnectionService.loading()) {
      <glxy-badge [color]="badge().color">
        {{ badge()!.i18nKey | translate }}
      </glxy-badge>
    }
    <mat-card-title>{{ 'INBOX.SETTINGS.WHATSAPP_MESSAGES.TITLE' | translate }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    @if (whatsappConnectionService.loading()) {
      <div class="loading-state">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    } @else {
      <p>
        <strong>{{ 'INBOX.SETTINGS.WHATSAPP_MESSAGES.DESCRIPTION' | translate }}</strong>
      </p>
      @if (connectedPhoneNumber()) {
        <p class="page-name">
          <strong>{{ 'INBOX.SETTINGS.WHATSAPP_MESSAGES.CONNECTED_PHONE_NUMBER' | translate }}:</strong>&nbsp;
          <span>{{ connectedPhoneNumber() }}</span>
        </p>
      }

      @switch (whatsappConnectionService.status()) {
        @case (MessagingStatus.NOT_CONNECTED) {
          <p>
            {{ 'INBOX.SETTINGS.WHATSAPP_MESSAGES.NOT_CONNECTED_DESCRIPTION' | translate }}
          </p>
          <p class="actions">
            <ng-container *ngTemplateOutlet="loginContent" />
          </p>
        }
        @case (MessagingStatus.CONNECTED) {
          <button mat-stroked-button [glxyPopover]="disconnectPopover" (click)="disconnectPopover.open()">
            {{ 'INBOX.SETTINGS.WHATSAPP_MESSAGES.DISCONNECT' | translate }}
          </button>
        }
        @case (MessagingStatus.TOKEN_INVALID) {
          <ng-container *ngTemplateOutlet="reconnectBadTokenSection" />
        }
        @case (MessagingStatus.EVENT_SUBSCRIPTION_MISSING) {
          <!-- Could also add a new facebook µs API to subscribe to webhook events on the WhatsApp Business Account (WABA)-->
          <ng-container *ngTemplateOutlet="reconnectDueToUnknownError" />
        }
        @case (MessagingStatus.UNKNOWN_ERROR) {
          <ng-container *ngTemplateOutlet="reconnectDueToUnknownError" />
        }
        @case (MessagingStatus.UNKNOWN) {
          <glxy-alert type="error">
            <p>
              <strong>{{ 'INBOX.SETTINGS.WHATSAPP_MESSAGES.ERRORS.UNKNOWN_ERROR' | translate }}</strong>
              <br />
              {{ 'INBOX.SETTINGS.WHATSAPP_MESSAGES.ERRORS.PLEASE_TRY_RECONNECTING' | translate }}
            </p>
            <ng-container *ngTemplateOutlet="loginContent" />
          </glxy-alert>
        }
      }

      @if (userHasInsufficientPermissions()) {
        <glxy-alert type="error">
          <p>
            <strong>{{ 'INBOX.SETTINGS.WHATSAPP_MESSAGES.ERRORS.PERMISSIONS_ERROR' | translate }}</strong>
            <br />
            {{ 'INBOX.SETTINGS.WHATSAPP_MESSAGES.ERRORS.PERMISSIONS_ERROR_DESCRIPTION' | translate }}
          </p>
        </glxy-alert>
      }
    }
  </mat-card-content>
</mat-card>

<ng-template #reconnectBadTokenSection>
  <glxy-alert type="error">
    <p>
      <strong>{{ 'INBOX.SETTINGS.WHATSAPP_MESSAGES.ERRORS.PERMISSIONS_ERROR' | translate }}</strong>
      <br />
      {{ 'INBOX.SETTINGS.WHATSAPP_MESSAGES.ERRORS.PLEASE_TRY_RECONNECTING' | translate }}
    </p>
    <ng-container *ngTemplateOutlet="loginContent" />
  </glxy-alert>
</ng-template>

<ng-template #reconnectDueToUnknownError>
  <glxy-alert type="error">
    <p>
      <strong>{{ 'INBOX.SETTINGS.WHATSAPP_MESSAGES.ERRORS.PERMISSIONS_ERROR' | translate }}</strong>
      <br />
      {{ 'INBOX.SETTINGS.WHATSAPP_MESSAGES.ERRORS.UNKNOWN_ERROR' | translate }}
    </p>
    <ng-container *ngTemplateOutlet="loginContent" />
  </glxy-alert>
</ng-template>

<glxy-popover #disconnectPopover>
  <glxy-popover-title>{{ 'INBOX.SETTINGS.WHATSAPP_MESSAGES.DISCONNECT_TITLE' | translate }}</glxy-popover-title>
  {{ 'INBOX.SETTINGS.WHATSAPP_MESSAGES.DISCONNECT_DESCRIPTION' | translate }}
  <glxy-popover-actions>
    <button mat-stroked-button (click)="disconnectPopover.close()">{{ 'INBOX.CANCEL' | translate }}</button>
    <button mat-flat-button color="warn" (click)="disconnect(); disconnectPopover.close()">
      {{ 'INBOX.SETTINGS.DISCONNECT' | translate }}
    </button>
  </glxy-popover-actions>
</glxy-popover>

<ng-template #loginContent>
  <ng-content select="login">
    <inbox-whatsapp-login [iframeSrc]="loginSrc()" />
  </ng-content>
</ng-template>
